// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

function getDate(data) {
	var date = Infinity; // tam asi nedojdem :D tvar z backendu YYYYMMDD
	for (var i = 0; i < data.length; i++) {
		if (data[i].date < date) { date = data[i].date }
	}
	if (date == Infinity) { return; }

	date = new Date(date*1000);
	var y = date.getFullYear();
	var m = date.getMonth()+1;
	var d = date.getDate();
	if (CONFIG.defaultLang === "en") {
		return d + "/" + m + "/" + y;
	}
	return d + ". " + m + ". " + y;
};

export default class Fuel extends Content {
	_build() {
		this._dom.container.classList.add("content-fuel");
		var date = getDate(this._data);

		this._dom.container.appendChild(node("h4", {innerHTML: (this._data.label ? this._data.label : (_("detail.content.fuel") + " " + date)) + ":"}));

		var data = this._data.label ? this._data.value : this._data;
		var table = node("table");
		for (var i = 0; i < data.length; i++) {
			var tr = node("tr");
			tr.setAttribute("itemscope", "itemscope");
			tr.setAttribute("itemtype", "http://schema.org/Product");

			var name = node("td", {innerHTML: data[i].name, className: "type-" + data[i].id});
			name.setAttribute("itemprop", "name");

			var priceValue = data[i].priceValue || "";
			var price = node("td");
			price.setAttribute("itemprop", "offers");
			price.setAttribute("itemscope", "itemscope");
			price.setAttribute("itemtype", "http://schema.org/Offer");

			var span = node("span", {innerHTML: data[i].price});
			span.setAttribute("itemprop", "price");
			span.setAttribute("content", priceValue);

			var meta = node("meta", {"content": data[i].currency});
			meta.setAttribute("itemprop", "priceCurrency");
			price.appendChild(span);
			price.appendChild(meta);

			tr.appendChild(name);
			tr.appendChild(price);

			table.appendChild(tr);
		}

		this._dom.container.appendChild(table);
	}
}
